// Faixa de rodadas do torneio. Este é um torneio de RETURNO do Brasileirão:
// vale da rodada 20 à 38 (não a temporada inteira). Fonte única para os
// seletores de rodada (Dashboard e Painel do Admin) e para o texto do hero —
// mudar aqui reflete em todos os lugares e evita que fiquem dessincronizados.
export const RODADA_INICIAL = 20;
export const RODADA_FINAL = 38;

// [20, 21, ..., 38] — usado nos <select> de rodada.
export const RODADAS_DO_TORNEIO = Array.from(
  { length: RODADA_FINAL - RODADA_INICIAL + 1 },
  (_, i) => i + RODADA_INICIAL,
);
